module.exports = function getResource(label, vars = []) {
    let resources = {
        seeAll: `Voir tout ${vars[0]}`
    };

    return resources[label];
};
